import React from "react";

const InputField = (props: any) => {
  return (
    <>
      <div className="form-floating">
        <input
          className="form-control"
          placeholder="name@example.com"
          {...props}
        />
        <label htmlFor="floatingInput">{props?.placeholder}</label>
      </div>
    </>
  );
};

export default InputField;
